import React, { Component } from 'react';
import c3 from 'c3';
import 'c3/c3.css';

export default class Chart_Trend extends Component {
	constructor(props) {
		super(props);
		this.state = {

		}
	}

	componentDidMount() {
		this.generateChart();
		window.addEventListener('resize', this.generateChart);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.generateChart);
	}

	generateChart = () => {
		let width = this.props.chart_width;
		let height = this.props.chart_height;
		let chart_data = this.props.chart_data

		/*
		 * rotates the x and y axis. if set to true, x and y axis will switch places
		 * is_rotated true = screen vertical
		 * is_rotated false = screen horizontal
		 * https://c3js.org/samples/axes_rotated.html
		 */
		let is_rotated = false;

		// Padding for the chart, we need padding so to show the axis labels
		// https://c3js.org/samples/options_padding.html
		let padding = { top: 0, right: 70, bottom: 0, left: 75 }; // screen horizontal
		//if(is_rotated) padding = {top: 0, right: 20, bottom: 0, left: 45}; // screen vertical

		// Time series display format
		// https://c3js.org/samples/timeseries.html
		let display_time_format = '%d-%b %H:%M';

		// Tick Values for x-axis
		// https://c3js.org/samples/axes_x_tick_values.html
		let tick_values = [];

		if (chart_data.length > 0) {
			// chart[0] = eg. ['x', '2013-01-01 00:00:00', '2013-01-01 01:00:00', ...]
			for (let time_stamp of chart_data[0]) {
				if (time_stamp != 'x') {
					let time_stamp_arr = time_stamp.split(' ');	 //2013-01-01 00:00:00
					let date_arr = time_stamp_arr[0].split('-'); //2013-01-01
					let time_arr = time_stamp_arr[1].split(':'); //00:00:00
					let year = date_arr[0];
					let month = date_arr[1];
					let day = date_arr[2];
					let hour = time_arr[0];
					let minute = time_arr[1];
					let second = time_arr[2];
					let temp_date = new Date(year, month, day, hour, minute, second, 0);

					if (parseInt(this.props.duration) <= 12) {
						// Every 1 hours
						if (temp_date.getMinutes() == 0) {
							tick_values.push(time_stamp);
						}
					} else if (parseInt(this.props.duration) <= 24) {
						// Every 2 hours
						if ((temp_date.getHours()) % 2 === 0 && temp_date.getMinutes() == 0) {
							tick_values.push(time_stamp);
						}
					} else {
						// Every 12 hours
						if ((temp_date.getHours()) % 12 === 0 && temp_date.getMinutes() == 0) {
							tick_values.push(time_stamp);
						}
					}
				}
			}

			if (tick_values.length < 1) {
				// todo use now to check instead
				for (let time_stamp of chart_data[0]) {
					if (time_stamp != 'x') {

						//Tommy 22/02/2021
						let time_stamp_arr = time_stamp.split(' ');
						let time_arr = time_stamp_arr[1].split(':');
						let minute = time_arr[1];

						//let temp_date = new Date(time_stamp);
						// Every 1 hours
						//Tommy 22/02/2021
						if (minute == 0) {
							tick_values.push(time_stamp);
						}
					}
				}
			}
		}

		// Whether to show each point in line.
		// https://c3js.org/samples/point_show.html
		let is_show_point = false;

		// Additional y axis 'y2' for total
		// https://c3js.org/samples/axes_y2.html
		let axes = {};

		// Y and Y2-axis labels
		let y_label = '';
		let y2_label = '';
		let is_show_y2 = false;
		let units = [];
		let labels = [];

		for (let index in chart_data) {
			let data = chart_data[index];
			if (data[0] != 'x') {
				let point_id = data[1];
				let point_info = window.app.state.point_list[point_id];

				let type = data[0];
				chart_data[index] = data.slice(1, data.length);
				let key = point_info.name;
				if (type != 'non') {
					key = key + '-' + window.app.receiver.getString(type); // eg. Ac-dtatcp1:1-00005-sp
				}
				// Cannot contain '.'
				key = key.replace(".", " ")
				chart_data[index][0] = key;

				let unit = 'DEG';
				if (point_info.unit != null) unit = point_info.unit;

				// Check if management point's usage is humi
				let label = getYLabel(unit);
				if (point_info.usage === "humi" || point_info.usage === "dehumi") {
					unit = window.app.receiver.getString('humi') + label;
				} else {
					unit = label;
				}

				// Check if existing unit already exist in the array of labels
				if (!labels.includes(unit)) {
					labels.push(unit);
				}

				if (labels[0] == unit) {
					axes[key] = 'y';
				}

				if (labels.length > 1 && labels[1] == unit) {
					axes[key] = 'y2';
				}
			}
		}

		if (labels.length > 0) {
			if (labels.length == 2) {
				is_show_y2 = true;
				y2_label = labels[1];
			}
			y_label = labels[0];
		}

		let chart = c3.generate({
			bindto: '#chart',
			padding: padding,
			size: {
				width: width,
				height: height,
			},
			data: {
				x: 'x',
				xFormat: '%Y-%m-%d %H:%M:%S', // Input time series format
				columns: chart_data,
				axes: axes,
			},
			axis: {
				x: {
					show: true,
					type: 'timeseries',
					tick: {
						format: display_time_format, // Display time series format
						values: tick_values,
						rotate: -45,
					}
				},
				y: {
					label: {
						text: y_label,
						position: 'outer-middle'
					},
					tick: {
						format: function (d) {
							if (Math.abs(d) >= 1000000) return (d / 1000000).toFixed(1) + 'M';
							else if (Math.abs(d) >= 1000) return (d / 1000).toFixed(1) + 'K';
							else return d;
						},
					},
				},
				y2: {
					show: is_show_y2,
					tick: {
						format: function (d) {
							if (Math.abs(d) >= 1000000) return (d / 1000000).toFixed(1) + 'M';
							else if (Math.abs(d) >= 1000) return (d / 1000).toFixed(1) + 'K';
							else return d;
						},
					},
					label: {
						text: y2_label,
						position: 'outer-middle',
					}
				}
			},

			tooltip: {

			},
			point: {
				show: is_show_point
			},

			legend: { // Give padding to prevent chart legends overlapping
				padding: 20
			}
		})

		return chart;
	}

	render() {
		let style = {};
		style = Object.assign(style, this.props.style);

		return (
			<div id="chart" style={style} />
		);
	}
}

function getYLabel(unit) {
	let label = '';

	switch (unit) {
		/*case getTempUnit():
			label = window.app.state.receiver.getString('temp') + " " + unit;
			break;*/
		//case "°F":
		case "°C":
		case "C":
		case "DEG":
			label = window.app.receiver.getString('temp') + " " + '°C';
			break;
		case "%":
			label = " " + unit;
			break;
		case "ppm":
			label = window.app.receiver.getString('co2') + " " + unit;
			break;
		case "µg/m3":
			label = "PM2.5" + " " + unit;
			break;
		// case "DEG":
		// 	label = window.app.receiver.getString("DEG");
		// 	break;
		case "Lux":
			label = "Lux";
			break;
		default:
			label = unit;
			break;
	}

	return label;
}